'use client'

// src/switch.web.tsx
import * as Switch from "@radix-ui/react-switch";
import * as Slot from "@rn-primitives/slot";
import * as React from "react";
import { Pressable as Pressable2, View as View2 } from "react-native";
var Root2 = React.forwardRef(
  ({
    asChild,
    checked,
    onCheckedChange,
    disabled,
    onPress: onPressProp,
    onKeyDown: onKeyDownProp,
    ...props
  }, ref) => {
    function onPress(ev) {
      onCheckedChange(!checked);
      onPressProp?.(ev);
    }
    function onKeyDown(ev) {
      onKeyDownProp?.(ev);
      if (ev.key === " ") {
        onCheckedChange(!checked);
      }
    }
    const Component = asChild ? Slot.Pressable : Pressable2;
    return <Switch.Root checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} asChild><Component
      ref={ref}
      disabled={disabled}
      onPress={onPress}
      onKeyDown={onKeyDown}
      {...props}
    /></Switch.Root>;
  }
);
Root2.displayName = "RootWebSwitch";
var Thumb2 = React.forwardRef(({ asChild, ...props }, ref) => {
  const Component = asChild ? Slot.View : View2;
  return <Switch.Thumb asChild><Component ref={ref} {...props} /></Switch.Thumb>;
});
Thumb2.displayName = "ThumbWebSwitch";
export {
  Root2 as Root,
  Thumb2 as Thumb
};
